import  buttonSpecialAnimated1Tpl from './animated-1'
import  buttonSpecialAnimated2Tpl from './animated-2'

export {
    buttonSpecialAnimated1Tpl,
    buttonSpecialAnimated2Tpl
}